function loadTwitterWidget() {
  var existing = document.getElementById("twitter-wjs");
  if (existing) existing.remove();

  var js = document.createElement("script");
  js.id = "twitter-wjs";
  js.src = "https://platform.twitter.com/widgets.js";
  js.onload = function() {
    console.log("[Twitter] widgets.js loaded");
    triggerTwitterEmbeds();
  };
  document.body.appendChild(js);
}

function triggerTwitterEmbeds() {
  var retryCount = 0;
  var maxRetries = 10;
  var interval = setInterval(function() {
    if (window.twttr && window.twttr.widgets) {
      window.twttr.widgets.load();
      console.log("[Twitter] widgets loaded successfully");
      clearInterval(interval);
    } else {
      retryCount++;
      console.log("[Twitter] waiting...", retryCount);
      if (retryCount >= maxRetries) clearInterval(interval);
    }
  }, 500);
}

document.addEventListener("DOMContentLoaded", loadTwitterWidget);

document.addEventListener("shopify:section:load", function(){
  setTimeout(loadTwitterWidget, 300);
});
document.addEventListener("shopify:page:load", loadTwitterWidget);
document.addEventListener("turbo:load", loadTwitterWidget);